module.exports = __webpack_public_path__ + "assets/img/169bf1b57e35e2e0302e18540bf77773.png";